module.exports = __webpack_public_path__ + "img/arrow-no-filled.a13ea4c1.svg";